import React from "react";
import { Link } from 'react-router-dom'
import styles from './ServiceSection.module.css'

const ServiceCard = ({ img, title, sdescription, slug }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <div className={`service-item ${styles.serviceCardWrapper}`} >
            <div className="icon">
                <img src={img} alt="img" />
            </div>
            <div className="text">
                <h3>{title}</h3>
                <p>{sdescription}</p>
            </div>
        </div>
    )
}


export default ServiceCard;